import './ConfirmDialog.less';
import React from 'react';
import {translate} from "../../i18n";
import Button from "../button/Button";

export default class ConfirmDialog extends React.Component {

    render() {
        const {title, message, confirmText, cancelText, confirm, cancel} = this.props;

        return <div className="confirm-dialog">
            {
                <div className="title">
                    {title || translate('Are you sure?')}
                </div>
            }
            <div className="body">
                {
                    message &&
                    <div className="message">
                        {message}
                    </div>
                }
                <div className="actions">
                    <Button
                        title={cancelText || translate('Cancel')}
                        appearance="text-neutral"
                        onClick={cancel}
                    />
                    <Button
                        title={confirmText || translate('Confirm')}
                        appearance="solid-primary"
                        onClick={confirm}
                    />
                </div>
            </div>
        </div>
    }
}
